import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@iso/lib//helpers/api';
import { types, actions } from './reducer';
import AlertService from '@iso/services/SettingsService/AlertService';

function* deleteAlert({ id }) {
    try {
        yield call(AlertService.deleteOne, id);
        yield put(actions.deleteAlertSucceeded(id));
    } catch (error) {
        yield put(actions.deleteAlertFailed(extractError(error)));
    }
}

function* watchDeleteAlert() {
    yield takeEvery(
        types.REQUEST_DELETE_ALERT,
        deleteAlert,
    );
}

function* deleteSaga() {
    yield all([
        fork(watchDeleteAlert),
    ]);
}

export default deleteSaga;
